// material-ui
import { useTheme, styled } from '@mui/material/styles';
import { Box, Grid, Typography } from '@mui/material';
// assets
import StorefrontTwoToneIcon from '@mui/icons-material/StorefrontTwoTone';
import TotalIncomeCard from '../Skeleton/TotalIncomeCard';
// types
import PropTypes from 'prop-types';
import MainCard from "../MainCard";
import { currencyFormatter } from '../Utils';

// styles
const CardWrapper = styled(MainCard)(({ theme }) => ({
    overflow: 'hidden',
    position: 'relative'
}));

// ==============================|| DASHBOARD - TOTAL INCOME LIGHT CARD ||============================== //

const TotalIncomeLightCardComponent = ({ isLoading , startDate, endDate, subTallyData, totalSpent}) => {
    const theme = useTheme();
    const totalAmountSum = subTallyData.reduce((acc, curr) => acc + parseInt(curr.TOTAL_AMOUNT), 0);

    return (
        <>
            {isLoading ? (
                <TotalIncomeCard />
            ) : (
                <CardWrapper border={false} content={false}>
                    <Box sx={{ p: 1 }}>

                        <Grid container spacing={2}>
                            <Grid item xs={6} alignItems="left" sx={{mt:1, mb:1}}>
                                    <Typography color="#8d8686" align='left' sx={{ fontSize: '1.8rem', fontWeight: 700 }}> Total Spend Ksh {currencyFormatter(totalSpent)}</Typography>

                            </Grid>
                            <Grid item xs={6} align="right" sx={{mt:1, mb:0}}>
                                <Typography color="#8d8686" align='right' sx={{ fontSize: '1.5rem', fontWeight: 500 }}> {startDate ? "Date Range: "+startDate :""} {endDate ? "to "+endDate :""}</Typography>

                            </Grid>

                        </Grid>
                    </Box>
                </CardWrapper>
            )}
        </>
    );
};

TotalIncomeLightCardComponent.propTypes = {
    isLoading: PropTypes.bool
};

export default TotalIncomeLightCardComponent;